import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8r78hbsnh2: FaireBrandEntity = {
  token: "b_8r78hbsnh2",
  type: "brand",
  name: "Snappy Puzzles",
  avatarUrl:
    "https://cdn.faire.com/fastly/17e8b35ab42b33dd38f8948225cd1abd6770ac942499f8058b6788c245c15cc3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/14cf6b3b5e700c82941a3247c09b77eece4d0f55be317e08c4d07c86eefe5268.png",
  logoUrl:
    "https://cdn.faire.com/fastly/17e8b35ab42b33dd38f8948225cd1abd6770ac942499f8058b6788c245c15cc3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14cf6b3b5e700c82941a3247c09b77eece4d0f55be317e08c4d07c86eefe5268.png",
  location: "Austin, TX, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Snappy Puzzles creates premium 1000-piece jigsaw puzzles designed for adults who value quality, modern design, and meaningful screen-free time. Founded with the belief that slowing down matters, our puzzles are made to feel as good as they look—both while puzzling and once completed.\n\nAll Snappy Puzzles are made in the USA using premium recycled chipboard, ribbon-cut pieces, and a smooth satin finish that reduces glare and enhances the overall experience. Our artwork focuses on bold color, clean composition, and approachable themes that resonate with gift shoppers and everyday customers alike.\n\nEach puzzle is designed to be easy to merchandise and easy to sell, with thoughtful packaging and artwork that stands out on shelves. The back of every box features our full collection, helping customers discover additional designs and encouraging repeat purchases.\n\nAs part of our commitment to screen-free connection, Snappy Puzzles operates a Buy 5, Give 1 program, donating puzzles to organizations that promote offline activities. This program is fully funded and managed by our brand and is not passed on to retail partners.\n\nSnappy Puzzles is a family-owned business focused on craftsmanship, consistency, and creating products retailers can feel confident carrying.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:27.629Z",
    importedBy: "entity-db-cli",
  },
};
